// Small info-blue pill that surfaces the submission count on a
// deliverable when it has been re-submitted (count > 1). Hidden on the
// first submission because the count adds noise without new signal.
// Carries an aria-label so screen-reader users hear the rework-cycle
// framing even though the visible text is the compact "Submission N".

import { clsx } from "clsx";

export interface SubmissionBadgeProps {
  count: number;
}

const BADGE_CLASS =
  "inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-caption font-medium bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400";

export default function SubmissionBadge({ count }: SubmissionBadgeProps) {
  if (count <= 1) return null;
  return (
    <span
      data-testid="submission-badge"
      aria-label={`Submission ${count} — rework cycle ${count - 1}`}
      className={clsx(BADGE_CLASS)}
    >
      ↻ Submission {count}
    </span>
  );
}
